import { ChangeDetectorRef, EventEmitter, NgZone, TemplateRef } from '@angular/core';
import { MessageService } from '../../../message/message.service';
import { MessageSendComponent } from '../../../session/chat-ui/message-send/message-send.component';
import { User } from '../../../../core/user/user.model';
import { Conversationn } from '../../../../shared/model/conversationn.model';
import { OfflineMessageService } from '../../../session/offline-message/offline-message.service';
import { TrackerService } from '../../../../core/tracker/tracker.service';
import { AccountService } from '../../../../core/auth/account.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { JhiLanguageService } from '../../../../ng-jhipster/language';
import { Message } from '../../../../shared/model/message.model';
import { UserService } from '../../../../core/user/user.service';
import { Session } from '../../../../shared/model/session.model';
import { CannedMessagesService } from '../../../../admin/canned-messages/canned-messages.service';
import { LANGUAGES } from '../../../../app.constants';
import * as i0 from "@angular/core";
import * as i1 from "../../../../ng-jhipster/language";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../../session/offline-message/offline-message.service";
import * as i4 from "../../../message/message.service";
import * as i5 from "../../../../core/auth/account.service";
import * as i6 from "../../../../core/tracker/tracker.service";
import * as i7 from "../../../../admin/canned-messages/canned-messages.service";
import * as i8 from "../../../../core/user/user.service";
import * as i9 from "../../../../shared/auth/has-any-authority.directive";
import * as i10 from "@angular/common";
import * as i11 from "@ctrl/ngx-emoji-mart";
import * as i12 from "@angular/forms";
import * as i13 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i14 from "@fortawesome/angular-fontawesome";
import * as i15 from "../../../../shared/auto-direction-switch/input-auto-direction-switch.directive";
import * as i16 from "@ngx-translate/core";
function OfflineMessageSendComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 29);
} }
function OfflineMessageSendComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "div", 31);
    i0.ɵɵelementStart(2, "div", 32);
    i0.ɵɵelementStart(3, "fa-icon", 33);
    i0.ɵɵlistener("click", function OfflineMessageSendComponent_div_2_Template_fa_icon_click_3_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.removeReply(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r1.messageToBeReplied == null ? null : ctx_r1.messageToBeReplied.message, i0.ɵɵsanitizeHtml);
} }
function OfflineMessageSendComponent_small_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r5.typingMessage, "\u200B");
} }
function OfflineMessageSendComponent_small_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 34);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "global.Sending..."));
} }
function OfflineMessageSendComponent_fa_icon_25_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 35);
    i0.ɵɵlistener("click", function OfflineMessageSendComponent_fa_icon_25_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); const _r9 = i0.ɵɵreference(32); return ctx_r13.open(_r9); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "inukaNgApp.offlineMessage.cannedResponses"));
} }
function OfflineMessageSendComponent_span_26_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵelementStart(1, "a", 5);
    i0.ɵɵlistener("click", function OfflineMessageSendComponent_span_26_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.openScriptsModal(); });
    i0.ɵɵelement(2, "img", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function OfflineMessageSendComponent_ng_template_31_div_4_option_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 54);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const lang_r21 = ctx.$implicit;
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngValue", lang_r21);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r20.getLanguage(lang_r21));
} }
function OfflineMessageSendComponent_ng_template_31_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelementStart(1, "select", 52);
    i0.ɵɵlistener("ngModelChange", function OfflineMessageSendComponent_ng_template_31_div_4_Template_select_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.selectedLanguage = $event; })("change", function OfflineMessageSendComponent_ng_template_31_div_4_Template_select_change_1_listener() { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.updateUserLanguage(ctx_r24.selectedLanguage); });
    i0.ɵɵtemplate(2, OfflineMessageSendComponent_ng_template_31_div_4_option_2_Template, 2, 2, "option", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r18.selectedLanguage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r18.cannedResponseLangList);
} }
function OfflineMessageSendComponent_ng_template_31_tr_22_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 55);
    i0.ɵɵlistener("click", function OfflineMessageSendComponent_ng_template_31_tr_22_Template_tr_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r27); const r_r25 = restoredCtx.$implicit; const modal_r17 = i0.ɵɵnextContext().$implicit; const ctx_r26 = i0.ɵɵnextContext(); const _r4 = i0.ɵɵreference(18); ctx_r26.selectCannedResponse(r_r25.text, _r4); return modal_r17.close(); });
    i0.ɵɵelementStart(1, "td", 56);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 56);
    i0.ɵɵelementStart(5, "span", 57);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵelement(8, "span", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵelement(10, "span", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r25 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(r_r25.lang);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", r_r25.tag);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate("/" + r_r25.tag);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", r_r25.englishTranslation, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", r_r25.text, i0.ɵɵsanitizeHtml);
} }
function OfflineMessageSendComponent_ng_template_31_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵelementStart(1, "fa-icon", 39);
    i0.ɵɵlistener("click", function OfflineMessageSendComponent_ng_template_31_Template_fa_icon_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r30); const modal_r17 = restoredCtx.$implicit; return modal_r17.close("close"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 40);
    i0.ɵɵelementStart(3, "input", 41);
    i0.ɵɵlistener("keydown.enter", function OfflineMessageSendComponent_ng_template_31_Template_input_keydown_enter_3_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.sendCannedResponse(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, OfflineMessageSendComponent_ng_template_31_div_4_Template, 3, 2, "div", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 43);
    i0.ɵɵelementStart(6, "table", 44);
    i0.ɵɵelementStart(7, "thead");
    i0.ɵɵelementStart(8, "tr");
    i0.ɵɵelementStart(9, "th", 45);
    i0.ɵɵelementStart(10, "span", 46);
    i0.ɵɵtext(11, "Response Language");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th", 45);
    i0.ɵɵelementStart(13, "span", 47);
    i0.ɵɵtext(14, "Response Tag");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th", 45);
    i0.ɵɵelementStart(16, "span", 48);
    i0.ɵɵtext(17, "Response English translation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "th", 45);
    i0.ɵɵelementStart(19, "span", 49);
    i0.ɵɵtext(20, "Response Text");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "tbody");
    i0.ɵɵtemplate(22, OfflineMessageSendComponent_ng_template_31_tr_22_Template, 11, 5, "tr", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r10.selectedLanguage);
    i0.ɵɵadvance(18);
    i0.ɵɵproperty("ngForOf", ctx_r10.filteredCannedResponseList);
} }
const _c0 = function () { return ["ROLE_CUSTOMER_CARE"]; };
const _c1 = function () { return { border: "none" }; };
const _c2 = function (a0) { return { "color": a0 }; };
export class OfflineMessageSendComponent extends MessageSendComponent {
    constructor(languageService, modalService, offlineMessageService, messageService, accountService, trackerService, cdr, ngZone, cannedMessagesService, userService) {
        super(messageService, accountService, trackerService, cdr, ngZone, modalService, languageService, userService);
        this.languageService = languageService;
        this.modalService = modalService;
        this.offlineMessageService = offlineMessageService;
        this.messageService = messageService;
        this.accountService = accountService;
        this.trackerService = trackerService;
        this.cdr = cdr;
        this.ngZone = ngZone;
        this.cannedMessagesService = cannedMessagesService;
        this.userService = userService;
        this.messageSent = new EventEmitter();
        this.modalOptions = { windowClass: 'modal-window', size: 'xl' };
        this.languageKeys = LANGUAGES;
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.isCustomerCareAccount) {
            this.cannedMessagesService.queryAsList().subscribe((res) => {
                this.cannedResponseList = res.body;
                this.cannedResponseLangList = [...new Set(this.cannedResponseList.map(r => r.lang))];
                this.selectLanguage();
            }, (error) => {
                console.log(error);
            });
        }
    }
    ngOnChanges() {
        super.ngOnChanges();
        if (this.cannedResponseLangList != null)
            this.selectLanguage();
    }
    selectLanguage() {
        this.selectedLanguage = this.cannedResponseLangList.includes(this.selectedUser.langKey) ? this.selectedUser.langKey : 'en';
        this.filteredCannedResponseList = JSON.parse(JSON.stringify(this.cannedResponseList.filter(r => r.lang === this.selectedLanguage)));
        console.log(this.selectedLanguage);
        console.log(this.filteredCannedResponseList);
    }
    typingNotify() {
        let now = Date.now();
        let innerHTML = this.messageSendContainer.nativeElement.innerHTML;
        if (innerHTML !== this.currentMessageValue) {
            console.log('notify');
            this.messageService.typing2(this.selectedUser.id).subscribe(() => {
                this.lastNotification = now;
                this.currentMessageValue = innerHTML;
            });
        }
        else {
            console.log('do not notify');
        }
        if (this.typing) {
            console.log('repeat notify');
            // this.typingNotify();
        }
        else {
            console.log('do not repeat notify');
        }
    }
    sendMessage(el, fileInput) {
        var _a;
        this.typing = false;
        let innerHTML = this.trim(el.innerHTML);
        let innerHTMLLength = innerHTML.length;
        if (innerHTML.startsWith('/') && this.isCustomerCareAccount) {
            let innerHTMLTag = innerHTML.slice(1, innerHTMLLength);
            innerHTML = this.cannedResponseList.filter(r => r.tag === innerHTMLTag)[0].text;
            this.message = innerHTML;
            return;
        }
        if (innerHTMLLength === 0 && this.fileB64 === undefined) {
            return;
        }
        if (innerHTMLLength > this.maxCharacterSize) {
            window.alert("Message size cannot be longer than " + this.maxCharacterSize);
            return;
        }
        if (this.sending) {
            return;
        }
        else {
            this.sending = true;
        }
        let request = {};
        request['message'] = (this.selectedFile != null || this.fileB64 !== undefined) ? '___filename___' + this.fileName + '___' + this.fileType + '___' + this.fileFormat + '___' + this.fileB64 : innerHTML;
        request["type"] = this.fileType;
        request['receiverId'] = this.selectedUser.id;
        request['convId'] = this.selectedConversation.id;
        request['sessionId'] = (_a = this.session) === null || _a === void 0 ? void 0 : _a.id;
        if (this.messageToBeReplied !== null && this.messageToBeReplied !== undefined)
            request['replyId'] = this.messageToBeReplied.id;
        this.offlineMessageService.sendMessage(request).subscribe(() => {
            this.messageToBeReplied = null;
            this.messageSent.emit(true);
            el.innerHTML = '';
            this.changeMessageCache(el);
            this.messageLength = 0;
            this.sending = false;
            this.selectedFile = null;
            fileInput.value = '';
            this.fileB64 = undefined;
            this.fileType = 'text';
        }, () => {
            window.alert('A problem has occurred sending the message');
            this.sending = false;
        }, () => {
            this.sending = false;
        });
    }
    openScriptsModal() {
    }
    open(content) {
        this.selectLanguage();
        this.modalService.open(content, this.modalOptions).result.then();
    }
    toggleDropdown(e) { }
    select(emoji, messageBox, dropdown) {
        if (emoji) {
            this.message = messageBox.textContent + emoji.emoji.native;
            dropdown.close();
            messageBox.focus();
        }
    }
    selectCannedResponse(text, messageBox) {
        this.message = text;
        messageBox.focus();
    }
    removeReply() {
        this.messageToBeReplied = null;
    }
    getLanguage(code) {
        return this.languageKeys.find(l => l.code === code).name;
    }
    updateUserLanguage(s) {
        this.filteredCannedResponseList = JSON.parse(JSON.stringify(this.cannedResponseList.filter(r => r.lang === s)));
    }
    sendCannedResponse() {
        let value = document.getElementById("canned-response-input").value;
        console.log(value);
        if (value.startsWith("/", 0)) {
            value = value.split("/")[1];
            let cannedResponse = this.filteredCannedResponseList.find(c => c.tag === value);
            console.log(cannedResponse);
            if (cannedResponse != null) {
                this.message = cannedResponse.text;
                console.log(this.message);
                document.getElementById("message-send-container").focus();
                document.getElementById("close-button").click();
            }
        }
    }
}
OfflineMessageSendComponent.ɵfac = function OfflineMessageSendComponent_Factory(t) { return new (t || OfflineMessageSendComponent)(i0.ɵɵdirectiveInject(i1.JhiLanguageService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.OfflineMessageService), i0.ɵɵdirectiveInject(i4.MessageService), i0.ɵɵdirectiveInject(i5.AccountService), i0.ɵɵdirectiveInject(i6.TrackerService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i7.CannedMessagesService), i0.ɵɵdirectiveInject(i8.UserService)); };
OfflineMessageSendComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OfflineMessageSendComponent, selectors: [["offline-message-send"]], inputs: { selectedUser: "selectedUser", selectedConversation: "selectedConversation", messageToBeReplied: "messageToBeReplied", session: "session" }, outputs: { messageSent: "messageSent" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 33, vars: 25, consts: [[1, "msb-reply", "px-1", "position-relative", "message-send-component"], ["jhiTranslate", "inukaNgApp.offlineMessage.slashForCannedResponse", "style", "font-style: italic; color: dimgray;", 4, "jhiHasAnyAuthority"], ["class", "row reply-div", 4, "ngIf"], [1, "d-flex", "flex-row", "message-row", 2, "width", "100%"], [1, "mt-2"], [3, "click"], ["type", "file", "accept", "image/*", 1, "d-none", 3, "change"], ["fileInput", ""], [1, "attachment-image", 2, "height", "1rem!important"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#attachment"], ["ngbDropdown", "", 1, "emoji-dropdown", 2, "margin-top", "6px!important", 3, "openChange"], ["emojiDropdown", "ngbDropdown"], ["ngbDropdownToggle", "", 1, "navbar-toggler"], [1, "smiling-face-empty-image", 2, "height", "1rem!important"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#smiling-face-empty"], ["ngbDropdownMenu", "", "emoji", "point_up", "title", "Pick your emoji", 3, "skin", "hideObsolete", "showSingleCategory", "perLine", "emojiClick"], [1, "input-div"], ["ngDefaultControl", "", "id", "message-send-container", "contenteditable", "true", 1, "form-control", "input-area", 3, "innerHTML", "ngModel", "ngModelChange", "keydown.enter", "keyup"], ["messageSendContainer", ""], [1, "indicator-div"], ["class", "font-weight-bold", "style", "color: #7CBFAE;", 4, "ngIf"], [1, "font-weight-bold", "float-right", 3, "ngStyle"], ["icon", "list-ul", "style", "font-size: 20px; margin: 0.1rem 0 0.1rem 0.1rem; padding: 0.1rem 0 0.1rem 0.1rem; color: #44a38d; cursor: pointer", 3, "title", "click", 4, "jhiHasAnyAuthority"], ["class", "d-lg-none my-1 ml-2", "style", "width: 32px", 4, "ngIf"], [1, "mt-2", "ml-2", 2, "width", "32px"], [3, "click", "mousedown"], [1, "arrow-head-image", 2, "height", "1rem!important"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#arrow-head"], ["cannedResponseModal", ""], ["jhiTranslate", "inukaNgApp.offlineMessage.slashForCannedResponse", 2, "font-style", "italic", "color", "dimgray"], [1, "row", "reply-div"], [1, "reply-text", 3, "innerHTML"], [1, "reply-cross"], ["role", "button", "icon", "times", 3, "click"], [1, "font-weight-bold", 2, "color", "#7CBFAE"], ["icon", "list-ul", 2, "font-size", "20px", "margin", "0.1rem 0 0.1rem 0.1rem", "padding", "0.1rem 0 0.1rem 0.1rem", "color", "#44a38d", "cursor", "pointer", 3, "title", "click"], [1, "d-lg-none", "my-1", "ml-2", 2, "width", "32px"], ["width", "24", "src", "../../../../../../../../../../../../content/images/inuka/script-icon.png", "alt", ""], [1, "d-flex", "justify-content-end", "p-2"], ["id", "close-button", "role", "button", "icon", "times", 1, "times", 2, "float", "right", "color", "black", "font-size", "20px", "margin", "5px 10px 5px 5px", 3, "click"], [1, "pl-4", "pr-4", "pb-4", "d-flex", "justify-content-between"], ["id", "canned-response-input", "type", "text", 1, "form-control", "pr-2", 3, "keydown.enter"], ["class", "pl-2", "style", "width: 100px;", 4, "ngIf"], [1, "pl-4", "pr-4", "commands-dialog"], [1, "table", "table-striped"], ["scope", "col"], ["jhiTranslate", "inukaNgApp.offlineMessage.responseLang"], ["jhiTranslate", "inukaNgApp.offlineMessage.responseTag"], ["jhiTranslate", "inukaNgApp.offlineMessage.responseEnglishTranslation"], ["jhiTranslate", "inukaNgApp.offlineMessage.responseText"], ["style", "cursor: pointer", 3, "click", 4, "ngFor", "ngForOf"], [1, "pl-2", 2, "width", "100px"], [1, "btn", "btn-mini", 3, "ngModel", "ngModelChange", "change"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [2, "cursor", "pointer", 3, "click"], ["width", "16%"], [3, "id"], [3, "innerHTML"], ["inputAutoDirectionSwitch", "", 3, "innerHTML"]], template: function OfflineMessageSendComponent_Template(rf, ctx) { if (rf & 1) {
        const _r32 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, OfflineMessageSendComponent_span_1_Template, 1, 0, "span", 1);
        i0.ɵɵtemplate(2, OfflineMessageSendComponent_div_2_Template, 4, 1, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "a", 5);
        i0.ɵɵlistener("click", function OfflineMessageSendComponent_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r32); const _r2 = i0.ɵɵreference(7); return _r2.click(); });
        i0.ɵɵelementStart(6, "input", 6, 7);
        i0.ɵɵlistener("change", function OfflineMessageSendComponent_Template_input_change_6_listener($event) { i0.ɵɵrestoreView(_r32); const _r4 = i0.ɵɵreference(18); return ctx.onFileSelected($event, _r4); });
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(8, "svg", 8);
        i0.ɵɵelement(9, "use", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(10, "div", 10, 11);
        i0.ɵɵlistener("openChange", function OfflineMessageSendComponent_Template_div_openChange_10_listener($event) { return ctx.toggleDropdown($event); });
        i0.ɵɵelementStart(12, "button", 12);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(13, "svg", 13);
        i0.ɵɵelement(14, "use", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(15, "emoji-mart", 15);
        i0.ɵɵlistener("emojiClick", function OfflineMessageSendComponent_Template_emoji_mart_emojiClick_15_listener($event) { i0.ɵɵrestoreView(_r32); const _r4 = i0.ɵɵreference(18); const _r3 = i0.ɵɵreference(11); return ctx.select($event, _r4, _r3); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 16);
        i0.ɵɵelementStart(17, "div", 17, 18);
        i0.ɵɵlistener("ngModelChange", function OfflineMessageSendComponent_Template_div_ngModelChange_17_listener($event) { return ctx.message = $event; })("keydown.enter", function OfflineMessageSendComponent_Template_div_keydown_enter_17_listener() { i0.ɵɵrestoreView(_r32); const _r4 = i0.ɵɵreference(18); const _r2 = i0.ɵɵreference(7); return ctx.onEnterPressed(_r4, _r2); })("keyup", function OfflineMessageSendComponent_Template_div_keyup_17_listener($event) { i0.ɵɵrestoreView(_r32); const _r4 = i0.ɵɵreference(18); return ctx.onInput($event, _r4); });
        i0.ɵɵpipe(19, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 19);
        i0.ɵɵtemplate(21, OfflineMessageSendComponent_small_21_Template, 2, 1, "small", 20);
        i0.ɵɵtemplate(22, OfflineMessageSendComponent_small_22_Template, 3, 3, "small", 20);
        i0.ɵɵelementStart(23, "small", 21);
        i0.ɵɵtext(24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(25, OfflineMessageSendComponent_fa_icon_25_Template, 2, 3, "fa-icon", 22);
        i0.ɵɵtemplate(26, OfflineMessageSendComponent_span_26_Template, 3, 0, "span", 23);
        i0.ɵɵelementStart(27, "div", 24);
        i0.ɵɵelementStart(28, "a", 25);
        i0.ɵɵlistener("click", function OfflineMessageSendComponent_Template_a_click_28_listener() { i0.ɵɵrestoreView(_r32); const _r4 = i0.ɵɵreference(18); const _r2 = i0.ɵɵreference(7); return ctx.sendMessage(_r4, _r2); })("mousedown", function OfflineMessageSendComponent_Template_a_mousedown_28_listener($event) { return $event.preventDefault(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(29, "svg", 26);
        i0.ɵɵelement(30, "use", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(31, OfflineMessageSendComponent_ng_template_31_Template, 23, 2, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(20, _c0));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.messageToBeReplied !== null && ctx.messageToBeReplied !== undefined);
        i0.ɵɵadvance(13);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(21, _c1));
        i0.ɵɵproperty("skin", 6)("hideObsolete", true)("showSingleCategory", true)("perLine", 8);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHTML", ctx.message, i0.ɵɵsanitizeHtml)("ngModel", ctx.message);
        i0.ɵɵattribute("aria-placeholder", i0.ɵɵpipeBind1(19, 18, "sessionChat.placeholder.typeAMessage"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !ctx.sending);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.sending);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(22, _c2, ctx.messageLength > ctx.maxCharacterSize ? "red" : "#7CBFAE"));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate2("", ctx.messageLength, " / ", ctx.maxCharacterSize, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(24, _c0));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayScriptsIcon);
    } }, directives: [i9.HasAnyAuthorityDirective, i10.NgIf, i2.NgbDropdown, i2.NgbDropdownToggle, i11.PickerComponent, i2.NgbDropdownMenu, i12.DefaultValueAccessor, i12.NgControlStatus, i12.NgModel, i10.NgStyle, i13.JhiTranslateDirective, i14.FaIconComponent, i10.NgForOf, i12.SelectControlValueAccessor, i12.NgSelectOption, i12.ɵNgSelectMultipleOption, i15.InputAutoDirectionSwitchDirective], pipes: [i16.TranslatePipe], styles: [".message-send-component[_ngcontent-%COMP%]{margin-top:20px !important}.message-row[_ngcontent-%COMP%]{margin-left:10px !important;margin-right:10px !important}.navbar-toggler[_ngcontent-%COMP%]{padding-top:0 !important}.input-div[_ngcontent-%COMP%]{width:90% !important;max-width:75% !important;margin-bottom:8px !important}.input-area[_ngcontent-%COMP%]{height:auto !important;max-height:58px !important;border:1px solid #cce9e0 !important;border-radius:6px !important;overflow-y:scroll !important}.input-area[_ngcontent-%COMP%]:empty:before{content:attr(aria-placeholder)}.input-area[_ngcontent-%COMP%]:focus{outline:none !important}.attachment-image[_ngcontent-%COMP%], .arrow-head-image[_ngcontent-%COMP%]{width:19px !important;height:auto !important}.smiling-face-empty-image[_ngcontent-%COMP%]{width:21px !important;height:auto !important}.indicator-div[_ngcontent-%COMP%]{line-height:1.2;margin-top:3px !important}.dropdown-menu[_ngcontent-%COMP%]{padding-top:0 !important;padding-bottom:0 !important}.commands-dialog[_ngcontent-%COMP%]{width:100%;max-height:700px;max-width:100%;overflow:auto}@media screen and (max-width: 620px){.commands-dialog[_ngcontent-%COMP%]{max-height:350px}}thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{position:sticky;top:0;z-index:1;background:#fff}.reply-div[_ngcontent-%COMP%]{max-width:75% !important;overflow-x:scroll !important;background-color:#eee;border-radius:6px;margin:5px auto !important}input[_ngcontent-%COMP%], select[_ngcontent-%COMP%]{outline:none !important}.reply-text[_ngcontent-%COMP%]{font-size:12px !important;text-align:left !important;padding:5px !important}.reply-cross[_ngcontent-%COMP%]{position:absolute !important;top:0 !important;right:10% !important}.input-div[_ngcontent-%COMP%]{width:84% !important;max-width:70% !important}@media(min-width: 576px){.input-div[_ngcontent-%COMP%]{width:85% !important;max-width:70% !important}.attachment-image[_ngcontent-%COMP%], .arrow-head-image[_ngcontent-%COMP%]{width:26px !important;height:auto !important}.smiling-face-empty-image[_ngcontent-%COMP%]{width:28px !important;height:auto !important}}@media(min-width: 768px){.message-row[_ngcontent-%COMP%]{margin-left:20px !important;margin-right:20px !important}.input-div[_ngcontent-%COMP%]{margin-bottom:16px !important}}@media(min-width: 1200px){.message-row[_ngcontent-%COMP%]{margin-left:20px !important;margin-right:20px !important}.input-div[_ngcontent-%COMP%]{width:90% !important;max-width:75% !important}}"] });
